import { getResource } from "./request";

const endpoint = "challenge/GetChallenges";

export async function getAllChallenges(data: ChallengeFormType) {
  if (data.challenge_name === "") {
    delete data.challenge_name;
  }
  const { response, error, code } = await getResource({ endpoint, data });
  return { response, error, code };
}

export interface ChallengeQuickstatsType {
  total_proposals: number;
  amount_requested: number;
  funded_proposals: number;
  funded_amount: number;
}

export interface ChallengeCardType {
  ranking: number;
  fund_id: number;
  challenge_id: number;
  fund_name: string;
  challenge_name: string;
  description: string;
  challenge_url: string;
  challenge_amount: number;
  number_of_proposals: number;
  includes_proposals_sponsored_by_leftovers: boolean;
  quick_stats_data: ChallengeQuickstatsType;
}

export interface ChallengeCardSummaryType {
  number_of_rows: number;
  items: ChallengeCardType[];
}

export interface ChallengeFormType {
  fund_id?: number[] | String;
  num_per_page: number;
  page_number: number;
  challenge_amount?: string;
  number_of_proposals?: string;
  challenge_name?: string;
  order_by?: string;
  ordering?: "asc" | "desc";
}

export interface ChallengeNameFormType {
  fundid: number[];
}

export const getSingleChallenge = async (data: singleChallengeFormType) => {
  const { response, error, code } = await getResource({
    endpoint: "challenge/GetChallenge",
    data,
  });
  return { response, error, code };
};

export type singleChallengeFormType = {
  challenge_id: number;
};

export interface ChallengeQuickstatsType {
  total_proposals: number;
  amount_requested: number;
  funded_proposals: number;
  funded_amount: number;
}

export interface ChallengeCardType {
  fund_id: number;
  challenge_id: number;
  fund_name: string;
  challenge_name: string;
  description: string;
  challenge_url: string;
  challenge_amount: number;
  number_of_proposals: number;
  quick_stats_data: ChallengeQuickstatsType;
}
